import { categorySchema } from '@/entities/shared/category/category';
import { CATEGORY_LABELS } from '@/entities/shared/category/category-labels';
import { ChipFilter } from '@/shared/components/chip-filter';
import { FilterSelect } from '@/shared/components/filter-select';
import { FiltersBar } from '@/shared/components/filters-bar';
import { SearchInput } from '@/shared/components/search-input';
import { msg } from '@/shared/i18n/msg';
import { useTranslation } from '@/shared/i18n/use-translation';
import { INVENTORY_FILTER_OPTIONS } from '../config/inventory-filter-options';
import type { useInventory } from '../hooks/use-inventory';

type InventoryToolbarProps = {
  readonly inventory: ReturnType<typeof useInventory>;
};

export function InventoryToolbar({ inventory }: InventoryToolbarProps) {
  const { t } = useTranslation();
  const { criteria, locations } = inventory;
  const active = [criteria.category, criteria.location].filter(Boolean).length;
  return (
    <div className="flex flex-col gap-3">
      <div className="flex gap-2 max-md:items-center md:flex-col lg:flex-row">
        <SearchInput
          placeholder={t('Search by name, brand, place…')}
          value={criteria.query}
          onChange={inventory.setQuery}
        />
        <FiltersBar
          active={active}
          onClear={() => {
            inventory.setCategory('');
            inventory.setLocation('');
          }}
        >
          <FilterSelect
            label={t('Category')}
            value={criteria.category}
            onChange={inventory.setCategory}
            options={[
              { value: '', label: msg('All categories') },
              ...categorySchema.options.map((value) => ({ value, label: CATEGORY_LABELS[value].label })),
            ]}
          />
          {locations.length > 0 && (
            <FilterSelect
              label={t('Location')}
              value={criteria.location}
              onChange={inventory.setLocation}
              options={[
                { value: '', label: msg('All locations') },
                ...locations.map((value) => ({ value, label: value })),
              ]}
            />
          )}
          <FilterSelect
            label={t('Sort')}
            value={criteria.sort}
            onChange={inventory.setSort}
            options={INVENTORY_FILTER_OPTIONS.sorts}
          />
        </FiltersBar>
      </div>
      <ChipFilter
        label={t('Filter')}
        value={criteria.filter}
        onChange={inventory.setFilter}
        options={INVENTORY_FILTER_OPTIONS.filters}
      />
    </div>
  );
}
